import React, { useEffect, useContext } from 'react';
import Flow from 'components/common/flow/flow';
import Heading from 'components/common/heading/heading';
import AppContext from 'contexts/appContext';
import SiteContext from 'components/shared/siteContext/siteContext';
import './menusScreenLayoutPage.css';

export default function MenusScreenPage(props) {
  const { setAppArea, setAppBreadcrumb } = useContext(AppContext);

  const screenId = props.match.params.id;

  useEffect(() => {
    setAppArea(AppContext.Areas.Menus, 'Edit Menu Screen');
    setAppBreadcrumb([{ name: 'Home', href: '/' }, { name: 'Menus', href: '/Menus' }, { name: `Screen #${screenId}`, selected: true }]);
  }, []);

  return (
    <Flow>
      <Flow.Header>
        <Heading>
          <SiteContext.Button hierarchyId={141} readOnly />
        </Heading>
      </Flow.Header>

      <Flow.Body>
        <h3 className='menus-screen-title mt-4'>{screenId}-PARTY PLATTERS TO GO</h3>
        <ScreenGrid screenId={screenId} />
      </Flow.Body>
    </Flow>
  );
}

function ScreenGrid(props) {
  const items = [
    {
      name: 'WINE FLIGHT',
      color: '#902D3B',
      start: 2,
      height: 2,
      width: 1,
    },
    {
      name: '12OZ BUD LIGHT',
      color: '#2D69A0',
      start: 4,
      height: 1,
      width: 1,
    },
    {
      name: 'A MENU ITEM',
      color: '#49A3A4',
      start: 10,
      height: 1,
      width: 1,
    },
    {
      name: '*SALADS*',
      color: '#313131',
      start: 14,
      height: 1,
      width: 1,
    },
    {
      name: 'EXPRESS MEAL',
      color: '#D1A546',
      start: 17,
      height: 1,
      width: 2,
    },
    {
      name: '#5 SPECIAL',
      color: '#3B6946',
      start: 23,
      height: 2,
      width: 2,
    },
    {
      name: 'WONDER BURGER',
      color: '#EA3732',
      start: 36,
      height: 1,
      width: 1,
    },
  ];

  const renderGrid = () => {
    const grid = [];
    const skips = [];
    for (let i = 0; i < 44; i++) {
      let position = i + 1;
      let skip = skips.find(a => a.start === position);
      if (skip) {
        grid.push(<ScreenGridHiddenCell position={skip.position} key={i} />);
      }
      else {
        const item = items.find(a => a.start === position);
        if (item) {
          if (item.height === 2 && item.width === 2) {
            skips.push({ start: position + 1, position: position });
            skips.push({ start: position + 11, position: null });
            skips.push({ start: position + 12, position: null });
            position = null;
          }
          else if (item.height === 2) {
            skips.push({ start: position + 1, position: position });
            position = null;
          }
          else if (item.width === 2) {
            skips.push({ start: position + 11, position: null });
          }
          grid.push(<ScreenGridItem item={item} position={position} screenId={props.screenId} key={i} />);
        }
        else {
          grid.push(<ScreenGridEmptyCell position={position} screenId={props.screenId} key={i} />);
        }
      }
    }
    return grid;
  };

  return (
    <div className='d-flex justify-content-center mt-2 mb-4'>
      <div className='menus-screen-grid'>
        {renderGrid()}
      </div>
    </div>
  );
}

function ScreenGridHiddenCell(props) {
  return (
    <div className='menus-screen-grid-cell cell-hidden'>
      <div className='position-label'>{props.position}</div>
    </div>
  );
}

function ScreenGridEmptyCell(props) {
  return (
    <a className='menus-screen-grid-cell cell-empty' href={`/Menus/Cell/${props.screenId * 100 + props.position}`}>
      <div className='position-label'>{props.position}</div>
    </a>
  );
}

function ScreenGridItem(props) {
  const item = props.item;

  return (
    <div className={`menus-screen-grid-cell cell-${item.height}x${item.width}`}>
      <div className='position-label'>{props.position}</div>
      <a className='menus-screen-grid-item' href={`/Menus/Cell/${props.screenId * 100 + item.start}`} style={{ backgroundColor: item.color }}>
        {item.name}
      </a>
    </div>
  );
}